import { Button, Icon } from '@zoom/components';
import { startOfDay } from 'date-fns';
import React, { RefObject, useState } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { MultipleDays } from '../../../components/DatePicker/MultipleDays';
import { CANCEL_CLONE_MENU_BUTTON_TAG, CONFIRM_CLONE_MENU_BUTTON_TAG } from '../constants';

interface CloneScheduleMenuProps extends WithTranslation {
  cloneSchedule?: (selectedDates: Date[]) => void;
  handleCancel: () => void;
  maxDate: Date;
  minDate: Date;
  pickedTime: Date;
  snackbarMessage: string;
  wrapperRef: RefObject<HTMLDivElement>;
}

const CloneScheduleMenuComponent: React.FC<CloneScheduleMenuProps> = ({
  cloneSchedule,
  handleCancel,
  maxDate,
  minDate,
  pickedTime,
  snackbarMessage,
  t,
  wrapperRef,
}) => {
  const [selectedDates, setSelectedDates] = useState<Date[]>();

  const handleSetSelectedDates = (dates: Date[]) => {
    setSelectedDates([...dates]);
  };

  const handleCloneSchedule = () => {
    if (selectedDates && cloneSchedule) {
      cloneSchedule(selectedDates);
      toast.success(t(snackbarMessage));
    }

    handleCancel();
  };

  const outOfRangeDays = [startOfDay(maxDate)];

  return (
    <div ref={wrapperRef}>
      <div className="clone-menu__header">{t('schedule.selectDatesForClone')}</div>
      <div className="clone-menu__calendar">
        <MultipleDays
          daysWithTooltip={outOfRangeDays}
          excludedDates={[pickedTime]}
          maxDate={maxDate}
          minDate={minDate}
          openToDate={pickedTime}
          selectedDates={selectedDates}
          setSelectedDates={handleSetSelectedDates}
          tooltipMessage={t('schedule.extraDayForOverflowingShifts')}
        />
      </div>
      <div className="clone-menu__button-wrapper">
        <Button
          className="button--icon--left-hand-side"
          color="info"
          data-test-id={CANCEL_CLONE_MENU_BUTTON_TAG}
          onClick={handleCancel}
        >
          <Icon color="#eb651c" kind="cross" size={10} />
          {t('layout.action.cancel')}
        </Button>
        <Button
          color="secondary"
          data-test-id={CONFIRM_CLONE_MENU_BUTTON_TAG}
          // eslint-disable-next-line no-restricted-syntax -- invalid rule for components from @zoom/components
          disabled={!(selectedDates && selectedDates.length)}
          onClick={handleCloneSchedule}
        >
          {t('schedule.clone')}
        </Button>
      </div>
    </div>
  );
};

export const CloneScheduleMenu = withTranslation()(CloneScheduleMenuComponent);
